module.exports = __webpack_public_path__ + "img/dash-chart.248b0b5d.svg";